module.exports = __webpack_public_path__ + "img/13.0abdbfa3.png";